import { useTranslation } from 'react-i18next';
import { getRuntimeConfig } from '@/config';

/**
 * VersionBadge — visible en el footer (regla universal del workspace,
 * ver CLAUDE.md §2 / RULES.md de plataformas Emilio Moro).
 *
 * Se alimenta del config de runtime (window.__THINGS360_CONFIG__) para
 * que un único bundle pueda mostrar versión distinta en dev/staging/prod
 * sin rebuild — nginx genera `/config.js` desde env vars en el contenedor.
 */
export function VersionBadge() {
  const { t } = useTranslation();
  const cfg = getRuntimeConfig();
  return (
    <span className="font-mono" title={`commit: ${cfg.build_commit}`} data-testid="version-badge">
      {t('footer.version')} {cfg.build_version} · {cfg.build_commit.slice(0, 7)}
    </span>
  );
}
